const fontHref =
  "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&family=Zen+Kaku+Gothic+New:wght@400;500;700&display=swap";

const ensureLink = (attributes) => {
  if (typeof document === "undefined") return;
  const selector = attributes.href
    ? `link[href="${attributes.href}"]`
    : `link[rel="${attributes.rel}"]`;
  if (document.querySelector(selector)) return;
  const link = document.createElement("link");
  Object.entries(attributes).forEach(([key, value]) => {
    link.setAttribute(key, value);
  });
  document.head.appendChild(link);
};

exports.onClientEntry = () => {
  ensureLink({ rel: "preconnect", href: "https://fonts.googleapis.com" });
  ensureLink({
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous",
  });
  ensureLink({ rel: "stylesheet", href: fontHref });
};
